import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f22426e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "value", "maxlength", "placeholder", "rows"]
const _hoisted_2 = ["id", "value", "maxlength", "placeholder", "onKeydown"]
const _hoisted_3 = ["title", "onClick"]
const _hoisted_4 = {
  key: 2,
  class: "inline-editable-text__display inline-editable-text__display--readonly"
}

import { computed, nextTick, ref, watch, withDefaults } from "vue";

interface Props {
  inputId?: string;
  maxLength?: number;
  modelValue?: string;
  multiline?: boolean;
  placeholder?: string;
  readonly?: boolean;
  rows?: number;
  title?: string;
}

type EditableElement = HTMLInputElement | HTMLTextAreaElement;


export default /*#__PURE__*/_defineComponent({
  __name: 'InlineEditableText',
  props: {
    inputId: { default: undefined },
    maxLength: { default: undefined },
    modelValue: { default: "" },
    multiline: { type: Boolean, default: false },
    placeholder: { default: "" },
    readonly: { type: Boolean, default: false },
    rows: { default: 3 },
    title: { default: "" }
  },
  emits: ["save", "update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: "save", value: string): void;
  (e: "update:modelValue", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { inputId: string, maxLength: number, modelValue: string, multiline: boolean, placeholder: string, readonly: boolean, rows: number, title: string };





const inputRef = ref<EditableElement | null>(null);
const isEditing = ref(false);
const draft = ref(props.modelValue);

const displayText = computed(() => props.modelValue || props.placeholder);

watch(() => props.modelValue, (nextValue) => {
  if (isEditing.value) {
    return;
  }

  draft.value = nextValue;
});

function beginEditing(): void {
  draft.value = props.modelValue;
  isEditing.value = true;
  nextTick(() => {
    inputRef.value?.focus();
  });
}

function updateDraft(event: Event): void {
  const value = (event.target as EditableElement | null)?.value ?? "";
  draft.value = value;
  emit("update:modelValue", value);
}

function finishEditing(): void {
  if (!isEditing.value) {
    return;
  }

  isEditing.value = false;
  emit("save", draft.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'inline-editable-text',
      __props.multiline ? 'inline-editable-text--multiline' : 'inline-editable-text--single-line',
    ])
  }, [
    (isEditing.value && !__props.readonly)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.multiline)
            ? (_openBlock(), _createElementBlock("textarea", {
                key: 0,
                id: __props.inputId,
                ref_key: "inputRef",
                ref: inputRef,
                class: "inline-editable-text__input",
                value: draft.value,
                maxlength: __props.maxLength,
                placeholder: __props.placeholder,
                rows: __props.rows,
                onInput: updateDraft,
                onBlur: finishEditing
              }, null, 40, _hoisted_1))
            : (_openBlock(), _createElementBlock("input", {
                key: 1,
                id: __props.inputId,
                ref_key: "inputRef",
                ref: inputRef,
                class: "inline-editable-text__input",
                type: "text",
                value: draft.value,
                maxlength: __props.maxLength,
                placeholder: __props.placeholder,
                onInput: updateDraft,
                onBlur: finishEditing,
                onKeydown: _withKeys(_withModifiers(finishEditing, ["prevent"]), ["enter"])
              }, null, 40, _hoisted_2))
        ], 64))
      : (!__props.readonly)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            title: __props.title,
            class: "inline-editable-text__display inline-editable-text__display--button",
            onClick: _withModifiers(beginEditing, ["stop"])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["inline-editable-text__content", { 'is-placeholder': !__props.modelValue }])
            }, _toDisplayString(_unref(displayText)), 3)
          ], 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass(["inline-editable-text__content", { 'is-placeholder': !__props.modelValue }])
            }, _toDisplayString(_unref(displayText)), 3)
          ]))
  ], 2))
}
}

})